import { useEffect, useState } from "react";
import Slider from "@material-ui/core/Slider";
import { makeStyles } from "@material-ui/core/styles";

import useContext from "../../../context";
import { findResort, getAvailableTerms, getLabeledTerms, getFallbackNotes, withEligibleTerms } from "../../../loanConfig";

/**
 * Label the terms where the interest rate changes, e.g. 4, 8, 12 or 4, 8, 10
 */
const getTermMarks = (terms, labeledTerms) => terms.map((term) => ({
  value: term,
  label: labeledTerms.includes(term) ? `${term} yrs` : undefined,
}));

// Keep every supported term selectable, but only draw marks with labels.
const useStyles = makeStyles({
  notes: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    marginTop: 16,
    overflowWrap: 'anywhere',
    '& p': { margin: 0, fontSize: 'inherit', lineHeight: 'inherit' },
    '& p + p': { marginTop: 8 },
  },
  mark: (marks) => marks.reduce((styles, mark, index) => {
    // JSS retains nested rules, so restore marks that were previously hidden.
    styles[`&[data-index="${index}"]`] = { display: mark.label ? "block" : "none" };
    return styles;
  }, {}),
});

export default function TermSlider() {
  const [context, updateContext] = useContext();
  // Shows the term while dragging; the quote updates when the slider is released
  const [draftTerm, setDraftTerm] = useState(context.term);

  useEffect(() => setDraftTerm(context.term), [context.term]);

  const resort = withEligibleTerms(context, findResort(context.config.resorts, context.resort));
  const terms = getAvailableTerms(context.config, resort);
  const marks = getTermMarks(terms, getLabeledTerms(resort, terms));
  const classes = useStyles(marks);
  const notes = getFallbackNotes(context);

  if (!terms.length || !context.term) {
    return null;
  }

  return (
    <div className="quoteform__input-group">
      <div className="quoteform__heading">Finance Term</div>
      <div className="quoteform__text">How many years would you like your loan to last?</div>
      <div className="quoteform__input quoteform__input-slider">
        <div className="slider">
          <Slider
            aria-label="Finance term"
            aria-describedby={notes.length ? "finance-term-fallback-notes" : undefined}
            getAriaValueText={(value) => `${value} years`}
            value={draftTerm}
            marks={marks}
            classes={{ mark: classes.mark }}
            step={null}
            min={terms[0]}
            max={terms[terms.length - 1]}
            onChange={(e, val) => setDraftTerm(val)}
            onChangeCommitted={(e, val) => updateContext((ctx) => {
              ctx.term = val;
              ctx.requestedTerm = val;
              ctx.termSelected = true;

              return ctx;
            })}
          />
        </div>
      </div>
      <div id="finance-term-fallback-notes" className={classes.notes} role="status" aria-live="polite" hidden={!notes.length}>
        {notes.map((note) => <p key={note}>* {note}</p>)}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// blocks/quote-calculator/app/components/LoanOptions/components/TermSlider.js